import { useCallback, useState } from 'react';

import { SubscriptionTopic } from '../../../../../../../viewer/messaging/pubsub';
import { DesignTool } from '../../../../../../../viewer/tools/design-tool';
import { SelectionResult } from '../../../../../../../viewer/tools/utils/context-menu/design-tool/utils/select';
import { useSubscribe } from '../../../../../../hooks/use-subscribe';

function selectionContainsItems(selection: SelectionResult) {
  return selection.faces.length + selection.lineSegments.length + selection.points.length > 0;
}

export function useCurrentSelection(tool: DesignTool) {
  const [currentSelection, setCurrentSelection] = useState<SelectionResult>(tool.currentSelection);
  const [multiSelectInProgress, setMultiselectInProgress] = useState(
    selectionContainsItems(tool.currentSelection),
  );

  const refresh = useCallback(() => {
    setMultiselectInProgress(selectionContainsItems(tool.currentSelection));
    setCurrentSelection({
      points: tool.currentSelection.points,
      lineSegments: tool.currentSelection.lineSegments,
      faces: tool.currentSelection.faces,
    });
  }, [tool]);

  useSubscribe(SubscriptionTopic.DesignToolMultiselectUpdated, () => {
    refresh();
  });

  return { currentSelection, multiSelectInProgress };
}
